import type { SVGProps } from "react";
import * as React from "react";
import { type iconSize, iconSizeVariants } from "@remi/types/icons";

type SvgIconProps = SVGProps<SVGSVGElement> & {
  size?: iconSize;
};
const Sun5pm = ({ size = "sm", ...props }: SvgIconProps) => {
  props.width = iconSizeVariants[size];
  props.height = iconSizeVariants[size];
  return (
    <svg {...props} viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M8.00012 1.31604C7.65494 1.31604 7.37512 1.59586 7.37512 1.94104V3.05903C7.37512 3.40421 7.65494 3.68403 8.00012 3.68403C8.3453 3.68403 8.62512 3.40421 8.62512 3.05903V1.94104C8.62512 1.59586 8.3453 1.31604 8.00012 1.31604Z"
        fill="currentColor"
      />
      <path
        d="M8.00012 12.316C7.65494 12.316 7.37512 12.5959 7.37512 12.941V14.059C7.37512 14.4042 7.65494 14.684 8.00012 14.684C8.3453 14.684 8.62512 14.4042 8.62512 14.059V12.941C8.62512 12.5959 8.3453 12.316 8.00012 12.316Z"
        fill="currentColor"
      />
      <path
        d="M1.31616 8C1.31616 8.34518 1.59598 8.625 1.94116 8.625H3.05915C3.40433 8.625 3.68415 8.34518 3.68415 8C3.68415 7.65482 3.40433 7.375 3.05915 7.375H1.94116C1.59598 7.375 1.31616 7.65482 1.31616 8Z"
        fill="currentColor"
      />
      <path
        d="M12.3162 8C12.3162 8.34518 12.596 8.625 12.9412 8.625H14.0592C14.4043 8.625 14.6842 8.34518 14.6842 8C14.6842 7.65482 14.4043 7.375 14.0592 7.375H12.9412C12.596 7.375 12.3162 7.65482 12.3162 8Z"
        fill="currentColor"
      />
      <path
        d="M3.27388 3.27376C3.0298 3.51784 3.0298 3.91357 3.27388 4.15764L4.06442 4.94818C4.3085 5.19226 4.70422 5.19226 4.9483 4.94818C5.19238 4.7041 5.19238 4.30838 4.9483 4.0643L4.15776 3.27376C3.91368 3.02968 3.51796 3.02968 3.27388 3.27376Z"
        fill="currentColor"
      />
      <path
        d="M11.052 11.052C10.8079 11.296 10.8079 11.6918 11.052 11.9358L11.8425 12.7264C12.0866 12.9705 12.4823 12.9705 12.7264 12.7264C12.9705 12.4823 12.9705 12.0866 12.7264 11.8425L11.9358 11.052C11.6918 10.8079 11.296 10.8079 11.052 11.052Z"
        fill="currentColor"
      />
      <path
        d="M3.27385 12.7264C3.51793 12.9704 3.91366 12.9704 4.15773 12.7264L4.94827 11.9358C5.19235 11.6917 5.19235 11.296 4.94827 11.0519C4.7042 10.8079 4.30847 10.8079 4.06439 11.0519L3.27385 11.8425C3.02977 12.0866 3.02977 12.4823 3.27385 12.7264Z"
        fill="currentColor"
      />
      <path
        d="M11.0519 4.94817C11.296 5.19225 11.6917 5.19225 11.9358 4.94817L12.7263 4.15763C12.9704 3.91355 12.9704 3.51782 12.7263 3.27374C12.4823 3.02967 12.0865 3.02967 11.8425 3.27374L11.0519 4.06428C10.8078 4.30836 10.8078 4.70409 11.0519 4.94817Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8.00019 11.6801C6.75388 11.6801 5.65228 11.0605 4.98656 10.1126C4.57408 9.56671 4.32007 8.82155 4.32007 8.00006C4.32007 7.17842 4.57417 6.43315 4.98678 5.88724C5.65251 4.93949 6.75402 4.32007 8.00019 4.32007C10.0326 4.32007 11.6802 5.96766 11.6802 8.00007C11.6802 10.0325 10.0326 11.6801 8.00019 11.6801ZM9.0312 8.00006C9.0312 8.99383 8.65947 9.87589 8.08516 10.4286C9.38787 10.3838 10.4302 9.31368 10.4302 8.00007C10.4302 6.68646 9.38788 5.61631 8.08519 5.57153C8.65948 6.12424 9.0312 7.0063 9.0312 8.00006Z"
        fill="currentColor"
      />
    </svg>
  );
};
export default Sun5pm;
